import { WhatsAppIcon } from './WhatsAppIcon';

const WHATSAPP_NUMBER = '551151250926';
const WHATSAPP_MESSAGE = 'Olá, vim pelo site de vocês. Quero fazer um orçamento para....';

export const WhatsAppButton = () => {
  const handleClick = () => {
    // Track WhatsApp click event for analytics
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'whatsapp_click',
        event_category: 'engagement',
        event_label: 'floating_button',
      });
    }
    
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
      '_blank'
    );
  };

  return (
    <button
      data-testid="whatsapp-floating-btn"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] hover:bg-[#20BD5A] rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0"
      aria-label="Falar no WhatsApp"
    >
      <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8 text-white" />
    </button>
  );
};

export default WhatsAppButton;
